<template>
  <div>
    <div class="page-title">Archived Issues</div>
    <!--Mobile Only-->
    <div class="mobile-menu hidden-md-up">
      <label>Jump to Volume: </label>
      <b-nav is-nav-bar>
        <b-nav-item-dropdown right is-nav class="nav mobile-menu" :text="selectedAnchor">
          <b-dropdown-item @click.native="selectedAnchor=item.text" v-for="item in anchorsList" :key="item.anchor"><router-link :to="{ path: '#' + item.anchor}">{{item.text}}</router-link></b-dropdown-item>
        </b-nav-item-dropdown>
      </b-nav>
    </div>
    <!--Mobile Only-->
    <template v-for="(item, index) in issues">
      <div class="issue" :id="'anchor'+item.issue_linkable || ''">
        <!--Non-Mobile Only-->
        <div class="hidden-sm-down row">
          <div class="col-md-3 col-sm-6 col-xs-12 text-center">
            <router-link :to="{ name: 'issueDetail', params: { volumeId: item.volume, issueId: item.issue }}" class="col">
              <img class="issue-cover" v-bind:src="item.optimized_urls.small"/>
            </router-link>
          </div>
          <div class="col-md-9 col-sm-6 col-xs-12">
            <div class="mb-2">
              <span class="text-accent">Issue:</span> Volume {{item.volume}}, Number {{item.issue}}&nbsp;|&nbsp;<span class="text-accent">Pages:</span> {{item.pages.start}} - {{item.pages.end}}
              <a class="article-link-item" @click="$root.$emit('show::modal','orderReprintModal', item)">Order a Reprint ></a>
            </div>
            <div class="text-accent">About the Cover</div>
            <div class="title"><router-link :to="{ name: 'issueDetail', params: { volumeId: item.volume, issueId: item.issue }}" class="col">Headline Headline Headline...</router-link></div>
            <div class="caption" v-html="item.caption"></div>
          </div>
        </div>
        <!--Non-Mobile Only-->
        <!--Mobile Only-->
        <div class="hidden-md-up row">

          <div class="col-md-9 col-sm-6 col-xs-12">
            <span class="text-accent">Issue:</span> Volume {{item.volume}}, Number {{item.issue}}&nbsp;<br />
            <span class="text-accent">Pages:</span> {{item.pages.start}} - {{item.pages.end}}
            <div class="text-accent">About the Cover</div>
            <div class="title"><router-link :to="{ name: 'issueDetail', params: { volumeId: item.volume, issueId: item.issue }}" class="col">Headline Headline Headline...</router-link></div>
          </div>
          <div class="my-4 col-sm-6 col-xs-12 text-center">
            <router-link :to="{ name: 'issueDetail', params: { volumeId: item.volume, issueId: item.issue }}" class="col">
              <img class="issue-cover" v-bind:src="item.optimized_urls.small"/>
            </router-link>
          </div>
          <div class="col-md-9 col-sm-6 col-xs-12">
            <div class="caption" v-html="item.caption"></div>
            <div class="text-center">
              <b-button class="button-secondary my-2 my-sm-0" variant="link" :to="{ name: 'issueDetail', params: { volumeId: item.volume, issueId: item.issue }}">
                View Issue
              </b-button><br />
              <b-button @click="$root.$emit('show::modal','orderReprintModal', item)" class="button-secondary my-2 my-sm-0" variant="link">
                Order a Reprint >
              </b-button>
            </div>

          </div>
        </div>
        <!--Mobile Only-->
      </div>
    </template>
  </div>
</template>

<script>
  import UtilityMixin from '@/components/shared/mixins/UtilityMixin'
  export default {
    components: {
    },
    mixins: [ UtilityMixin ],
    name: 'archived-issues',
    data () {
      return {
        issues: [],
        anchorsList: [],
        selectedAnchor: ''
      }
    },
    created () {
      this.$http.get(this.$store.state.dataUrlIssue).then(function (response) {
        var issue = response.body
        // ToDo: remove this line after services updates
        this.issues = [ Object.assign({}, issue, {issue_linkable: '1'}), Object.assign({}, issue, {issue_linkable: '2', issue: 999}) ]
        // ToDO: --end
        this.anchorsList = this.issues.map(function (item) {
          return {text: 'Volume ' + item.volume + ', Number ' + item.issue + ' | ' + 'Pages: ' + item.pages.start + ' - ' + item.pages.end, anchor: 'anchor' + item.issue_linkable}
        })
        this.selectedAnchor = this.anchorsList[0] ? this.anchorsList[0].text : ''
      }, function () {
      })
    }
  }
</script>


<style scoped lang="scss">
  .issue {
    margin-bottom: 30px;
    margin-top: 30px;
    @media (min-width: $breakpoint-sm) {
      padding: 20px;
    }
    &:not(:last-child) {
       border-bottom: 1px solid $devider;
    }
    &:before {
       display: block;
       content: "";
       height: 50px;
       margin: -50px 0 0;
    }

  .text-accent {
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    text-align: left;
    color: $primary-color;
    opacity: 0.6;
    margin-bottom: 7.5px;
  }
  .title {
    a {
      font-family: 'Merriweather', serif;
      font-size: 24px;
      font-weight: 300;
      line-height: 1.25;
      text-align: left;
      color: $accent-color-1;
      margin-bottom: $spacing-large;
      text-decoration: underline;
      padding: 0px;
    }
  }
  .issue-cover {
    margin-right: 12px;
    height: 150px;
  }
  .article-link-item {
    float: right;
  }
  }
  .mobile-menu {
    label {
      color: $secondary-color;
    }
  }
</style>



// WEBPACK FOOTER //
// ArchivedIssuesPage.vue?4464d9ba